import { Link } from 'react-router-dom'

export default function NotFound() {
  return (
    <main className="min-h-screen bg-bg flex items-center justify-center p-8">
      <div>
        <h1 className="text-[1.4rem] font-bold text-text-heading m-0 mb-4">404 — Page not found</h1>
        <Link to="/" className="text-accent no-underline font-medium hover:underline">Return home</Link>
      </div>
    </main>
  )
}
